'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AVAILABLE_DIRECTIONS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _eTail = (require('./__tail/popup2__tail.react.js').default || require('./__tail/popup2__tail.react.js')).applyDecls();

var _eTail2 = _interopRequireDefault(_eTail);

var _iBem = require('../i-bem/i-bem.react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AVAILABLE_DIRECTIONS = exports.AVAILABLE_DIRECTIONS = ['bottom-left', 'bottom-center', 'bottom-right', 'top-left', 'top-center', 'top-right', 'right-top', 'right-center', 'right-bottom', 'left-top', 'left-center', 'left-bottom'];

exports.default = (0, _iBem.decl)({
    block: 'popup2',
    getChildContext: function getChildContext() {
        return {
            registerChildPopup: this._registerChildPopup,
            unRegisterChildPopup: this._unRegisterChildPopup,
            zIndexGroupLevel: this._zIndexGroupLevel
        };
    },
    willInit: function willInit(_ref) {
        var scope = _ref.scope;

        this.__base.apply(this, arguments);

        this.defaultMainOffset = 0;
        this.defaultViewportOffset = 0;
        this.drawn = false;
        this.redrawTimer = null;

        this._style = { popup: {}, tail: {} };
        // TODO: https://st.yandex-team.ru/ISL-4719
        this._scope = scope || (typeof document !== 'undefined' ? document.body : null);
        this._childPopups = [];
        this._hasOpenedChildPopups = false;
        this._zIndex = null;
        this._zIndexGroupLevel = null;

        this._onWinScrollAndResize = this._onWinScrollAndResize.bind(this);
        this._registerChildPopup = this._registerChildPopup.bind(this);
        this._unRegisterChildPopup = this._unRegisterChildPopup.bind(this);
        this.toggleWatchBaseEvents = this.toggleWatchBaseEvents.bind(this);
    },
    didMount: function didMount() {
        var _this = this;

        if (typeof this.context.registerChildPopup === 'function') {
            this.context.registerChildPopup(this);
        }

        this.hasDOMNode = false;
        this._container = document.createElement('div');
        this._scope.appendChild(this._container);
        this.redraw(this.props);

        if (this.props.visible) {
            this.toggleWatchBaseEvents(true);
            this.redrawTimer = setTimeout(function () {
                return _this.redraw(_this.props);
            }, 0);
        }
    },
    willReceiveProps: function willReceiveProps(_ref2) {
        var visible = _ref2.visible,
            scope = _ref2.scope;

        if (visible && scope && this._scope !== scope) {
            this._scope.removeChild(this._container);
            this._scope = scope;
            this._scope.appendChild(this._container);
        }

        if (this.props.visible === visible) {
            return;
        }

        if (!visible) {
            this._releaseZIndex();
        }

        this.toggleWatchBaseEvents(visible);
    },
    willUpdate: function willUpdate(nextProps) {
        var _this2 = this;

        this.hasDOMNode = true;
        // Отрендерить контент, чтобы можно было померить высоту
        this.redraw(nextProps);

        // Отрендерить popup повторно с учётом высоты контента
        this.redrawTimer && clearTimeout(this.redrawTimer);
        this.redrawTimer = setTimeout(function () {
            _this2.hasDOMNode && _this2.redraw(nextProps);
            _this2.redrawTimer = null;
        }, 0);
    },
    willUnmount: function willUnmount() {
        if (typeof this.context.unRegisterChildPopup === 'function') {
            this.context.unRegisterChildPopup(this);
        }
        this.hasDOMNode = false;
        (0, _reactDom.unmountComponentAtNode)(this._container);
        this._scope.removeChild(this._container);
        this.toggleWatchBaseEvents(false);

        if (this.redrawTimer !== null) {
            clearTimeout(this.redrawTimer);
            this.redrawTimer = null;
        }
    },
    mods: function mods(_ref3) {
        var theme = _ref3.theme,
            visible = _ref3.visible,
            direction = _ref3.direction,
            view = _ref3.view,
            tone = _ref3.tone;

        return {
            view: view,
            tone: tone,
            theme: theme,
            direction: this._direction,
            visible: this.__self.bool2string(visible)
        };
    },
    attrs: function attrs(_ref4) {
        var onMouseOver = _ref4.onMouseOver,
            onMouseLeave = _ref4.onMouseLeave;

        return _extends({}, this.__base.apply(this, arguments), {
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave
        });
    },
    content: function content(_ref5) {
        var children = _ref5.children;

        return children;
    },
    toggleWatchBaseEvents: function toggleWatchBaseEvents(watch) {
        if (watch) {
            window.addEventListener('scroll', this._onWinScrollAndResize);
            window.addEventListener('resize', this._onWinScrollAndResize);
        } else {
            window.removeEventListener('scroll', this._onWinScrollAndResize);
            window.removeEventListener('resize', this._onWinScrollAndResize);
        }
    },
    redraw: function redraw(props) {
        var popup = this.draw(props);
        return this.__self.inject(this, popup, this._container);
    },
    draw: function draw(props) {
        var _this3 = this;

        var hasTail = props.hasTail,
            tailSize = props.tailSize,
            visible = props.visible;


        if (visible && this.domElementPopup) {
            var _calcBestDrawingParam = this._calcBestDrawingParams(props),
                left = _calcBestDrawingParam.left,
                top = _calcBestDrawingParam.top,
                tail = _calcBestDrawingParam.tail,
                direction = _calcBestDrawingParam.direction;

            var scopeOffsets = this._scope.getBoundingClientRect();

            // При [обязательном] наличии у scope position:relative необходимо
            // для корректного отображения popup'a относительно scope.
            // В FF не работает document.body.scrollTop, а в Chrome не работает document.documentElement.scrollTop.
            left -= scopeOffsets.left + window.pageXOffset;
            top -= scopeOffsets.top + window.pageYOffset;

            if (!this.drawn && this.props.visible) {
                this._captureZIndex();
                this.drawn = true;
            }

            props.calcPossible && this._calcPossibleDrawingParams(props);

            this._style.popup = _extends({}, this._style.popup, { left: left, top: top }, props.style);
            this._direction = direction;

            if (hasTail) {
                this._style.tail = _extends({}, tail, { width: tailSize, height: tailSize });
            }
        }

        var className = this.__self.classBuilder.stringify(this.block, this.elem, this.mods(props), this.__self.classBuilder.joinMixes(this.mix(props)), this.cls(props));
        var Tag = this.tag(props);
        var popup = _react2.default.createElement(
            Tag,
            _extends({
                className: className,
                style: _extends({}, this._style.popup)
            }, this.attrs(props), {
                ref: function ref(p) {
                    return _this3.domElementPopup = (0, _reactDom.findDOMNode)(p);
                } }),
            hasTail && _react2.default.createElement(_eTail2.default, {
                style: this._style.tail,
                ref: function ref(t) {
                    return _this3.domElementTail = (0, _reactDom.findDOMNode)(t);
                } }),
            this.content(props)
        );

        return popup;
    },
    render: function render() {
        return null;
    },

    /**
     * @param {ReactComponent} popup
     * @private
     */
    _registerChildPopup: function _registerChildPopup(popup) {
        this._childPopups.push(popup);
    },

    /**
     * @param {ReactComponent} popup
     * @private
     */
    _unRegisterChildPopup: function _unRegisterChildPopup(popup) {
        var index = this._childPopups.indexOf(popup);
        if (index !== -1) {
            this._childPopups.splice(index, 1);
        }
    },

    /**
     * @param {Element} element
     * @returns {boolean}
     */
    isElementInsideChildPopups: function isElementInsideChildPopups(element) {
        return this._childPopups.some(function (popup) {
            return popup.domElementPopup.contains(element) || popup.isElementInsideChildPopups(element);
        });
    },
    _onWinScrollAndResize: function _onWinScrollAndResize() {
        this.redraw(this.props);
    },
    _calcPossibleDrawingParams: function _calcPossibleDrawingParams(props) {
        var _this4 = this;

        var target = this._calcTargetDimensions(props);
        var viewport = this._calcViewportDimensions();
        var offsets = this._calcOffsets();
        var directions = props.directions;


        props.calcPossible(directions.map(function (direction) {
            var res = {
                direction: direction,
                width: 0,
                height: 0,
                left: 0,
                top: 0
            };

            if (_this4._checkMainDirection(direction, 'bottom')) {
                res.top = target.top + target.height + offsets.main;
                res.height = viewport.bottom - res.top - offsets.viewport;
            } else if (_this4._checkMainDirection(direction, 'top')) {
                res.height = target.top - viewport.top - offsets.main - offsets.viewport;
                res.top = target.top - res.height - offsets.main;
            } else {
                if (_this4._checkSecondaryDirection(direction, 'center')) {
                    res.height = viewport.bottom - viewport.top - 2 * offsets.viewport;
                    res.top = target.top + (target.height - res.height) / 2;
                } else if (_this4._checkSecondaryDirection(direction, 'bottom')) {
                    res.height = target.top + target.height - viewport.top - offsets.secondary - offsets.viewport;
                    res.top = target.top + target.height - res.height - offsets.secondary;
                } else if (_this4._checkSecondaryDirection(direction, 'top')) {
                    res.top = target.top + offsets.secondary;
                    res.height = viewport.bottom - res.top - offsets.viewport;
                }

                if (_this4._checkMainDirection(direction, 'left')) {
                    res.width = target.left - viewport.left - offsets.main - offsets.viewport;
                    res.left = target.left - res.width - offsets.main;
                } else {
                    res.left = target.left + target.width + offsets.main;
                    res.width = viewport.right - res.left - offsets.viewport;
                }
            }

            if (_this4._checkSecondaryDirection(direction, 'right')) {
                res.width = target.left + target.width - viewport.left - offsets.secondary - offsets.viewport;
                res.left = target.left + target.width - res.width - offsets.secondary;
            } else if (_this4._checkSecondaryDirection(direction, 'left')) {
                res.left = target.left + offsets.secondary;
                res.width = viewport.right - res.left - offsets.viewport;
            } else if (_this4._checkSecondaryDirection(direction, 'center')) {
                if (_this4._checkMainDirection(direction, 'top', 'bottom')) {
                    res.width = viewport.right - viewport.left - 2 * offsets.viewport;
                    res.left = target.left + target.width / 2 - res.width / 2;
                }
            }

            return res;
        }));
    },
    _calcBestDrawingParams: function _calcBestDrawingParams(props) {
        var popup = this._calcPopupDimensions();
        var target = this._calcTargetDimensions(props);
        var viewport = this._calcViewportDimensions();
        var directions = props.directions;

        var directionsLength = directions.length;

        var direction = void 0,
            pos = void 0,
            viewportFactor = void 0,
            bestDirection = void 0,
            bestPos = void 0,
            bestViewportFactor = void 0;

        for (var i = 0; i < directionsLength; i++) {
            direction = directions[i];
            pos = this._calcPos(direction, target, popup);
            viewportFactor = this._calcViewportFactor(pos, viewport, popup);

            if (i === 0 || viewportFactor > bestViewportFactor || !bestViewportFactor && props.direction === direction) {
                bestDirection = direction;
                bestViewportFactor = viewportFactor;
                bestPos = pos;
            }

            if (bestViewportFactor > this.__self.VIEWPORT_ACCURACY_FACTOR) {
                break;
            }
        }

        return {
            direction: bestDirection,
            left: bestPos.left,
            top: bestPos.top,
            tail: this._calcTailPos(bestDirection, target, popup, bestPos)
        };
    },
    _calcPopupDimensions: function _calcPopupDimensions() {
        var _domElementPopup = this.domElementPopup,
            clientWidth = _domElementPopup.clientWidth,
            clientHeight = _domElementPopup.clientHeight;

        var _domElementPopup$getB = this.domElementPopup.getBoundingClientRect(),
            width = _domElementPopup$getB.width,
            height = _domElementPopup$getB.height;

        return {
            // Погрешность при расчете offsetWidth при рендеринге в chrome
            width: Math.round(width),
            // Погрешность расчета при рендеринге IE11
            height: Math.round(height),
            popupWidth: clientWidth,
            popupHeight: clientHeight,
            area: clientWidth * clientHeight
        };
    },
    _calcTargetDimensions: function _calcTargetDimensions(_ref6) {
        var target = _ref6.target,
            position = _ref6.position;

        if (!target && !position) {
            return { left: 0, top: 0, width: 0, height: 0 };
        }

        return _extends({}, position, { width: 0, height: 0 });
    },
    _calcTailDimension: function _calcTailDimension() {
        if (this.props.tailSize) {
            return this.props.tailSize;
        }
        // В IE9 .outerWidth() возвращает ширину элемента, даже если он скрыт, поэтому явно проверяем на display: none;
        if (this.domElementTail && this.domElementTail.style.display !== 'none') {
            return this.domElementTail.offsetWidth;
        }

        return 0;
    },
    _calcViewportDimensions: function _calcViewportDimensions() {
        var winTop = window.pageYOffset;
        var winLeft = window.pageXOffset;
        var winWidth = window.innerWidth;
        var winHeight = window.innerHeight;

        return {
            top: winTop,
            left: winLeft,
            bottom: winTop + winHeight,
            right: winLeft + winWidth
        };
    },
    _calcPos: function _calcPos(direction, target, popup) {
        var res = {};
        var offsets = this._calcOffsets();

        if (this._checkMainDirection(direction, 'bottom')) {
            res.top = target.top + target.height + offsets.main;
        } else if (this._checkMainDirection(direction, 'top')) {
            res.top = target.top - popup.height - offsets.main;
        } else if (this._checkMainDirection(direction, 'left')) {
            res.left = target.left - popup.width - offsets.main;
        } else if (this._checkMainDirection(direction, 'right')) {
            res.left = target.left + target.width + offsets.main;
        }

        if (this._checkSecondaryDirection(direction, 'right')) {
            res.left = target.left + target.width - popup.width - offsets.secondary;
        } else if (this._checkSecondaryDirection(direction, 'left')) {
            res.left = target.left + offsets.secondary;
        } else if (this._checkSecondaryDirection(direction, 'bottom')) {
            res.top = target.top + target.height - popup.height - offsets.secondary;
        } else if (this._checkSecondaryDirection(direction, 'top')) {
            res.top = target.top + offsets.secondary;
        } else if (this._checkSecondaryDirection(direction, 'center')) {
            if (this._checkMainDirection(direction, 'top', 'bottom')) {
                res.left = target.left + target.width / 2 - popup.width / 2;
            } else if (this._checkMainDirection(direction, 'left', 'right')) {
                res.top = target.top + target.height / 2 - popup.height / 2;
            }
        }

        return res;
    },
    _calcViewportFactor: function _calcViewportFactor(pos, viewport, popup) {
        var viewportOffset = this.props.viewportOffset || this.defaultViewportOffset;
        var intersectionLeft = Math.max(pos.left, viewport.left + viewportOffset);
        var intersectionRight = Math.min(pos.left + popup.width, viewport.right - viewportOffset);
        var intersectionTop = Math.max(pos.top, viewport.top + viewportOffset);
        var intersectionBottom = Math.min(pos.top + popup.height, viewport.bottom - viewportOffset);

        if (!(intersectionLeft < intersectionRight && intersectionTop < intersectionBottom)) {
            // Нет пересечения
            return 0;
        }

        return (intersectionRight - intersectionLeft) * (intersectionBottom - intersectionTop) / popup.area;
    },
    _calcTailPos: function _calcTailPos(direction, target, popup, pos) {
        var res = {};
        var halfOfTail = this._calcTailDimension() / 2;
        var tailOffset = this.props.tailOffset;


        if (this._checkMainDirection(direction, 'bottom')) {
            res.top = -halfOfTail;
        } else if (this._checkMainDirection(direction, 'top')) {
            res.top = Math.floor(popup.popupHeight - halfOfTail);
        } else if (this._checkMainDirection(direction, 'left')) {
            res.left = Math.floor(popup.popupWidth - halfOfTail);
        } else if (this._checkMainDirection(direction, 'right')) {
            res.left = -halfOfTail;
        }

        if (this._checkSecondaryDirection(direction, 'right')) {
            res.left = popup.popupWidth - Math.ceil(Math.min(popup.popupWidth, target.width) / 2) - halfOfTail - tailOffset;
        } else if (this._checkSecondaryDirection(direction, 'left')) {
            res.left = Math.ceil(Math.min(popup.popupWidth, target.width) / 2) - halfOfTail + tailOffset;
        } else if (this._checkSecondaryDirection(direction, 'bottom')) {
            res.top = popup.popupHeight - Math.ceil(Math.min(popup.popupHeight, target.height) / 2) - halfOfTail - tailOffset;
        } else if (this._checkSecondaryDirection(direction, 'top')) {
            res.top = Math.ceil(Math.min(popup.popupHeight, target.height) / 2) - halfOfTail + tailOffset;
        } else if (this._checkSecondaryDirection(direction, 'center')) {
            if (this._checkMainDirection(direction, 'top', 'bottom')) {
                res.left = Math.ceil(popup.popupWidth / 2) - halfOfTail + tailOffset;
            } else {
                res.top = Math.ceil(popup.popupHeight / 2) - halfOfTail + tailOffset;
            }
        }

        return res;
    },
    _calcOffsets: function _calcOffsets() {
        var tailDimension = this._calcTailDimension();
        var mainOffset = this.props.mainOffset || this.defaultMainOffset;

        return {
            main: tailDimension > 0 ? Math.max(mainOffset, Math.round(tailDimension * Math.SQRT1_2)) : mainOffset,
            secondary: this.props.secondaryOffset,
            viewport: this.props.viewportOffset || this.defaultViewportOffset
        };
    },
    _checkMainDirection: function _checkMainDirection(direction, mainDirection1, mainDirection2) {
        return direction.indexOf(mainDirection1) === 0 || mainDirection2 && direction.indexOf(mainDirection2) === 0;
    },
    _checkSecondaryDirection: function _checkSecondaryDirection(direction, secondaryDirection) {
        return direction.indexOf('-' + secondaryDirection) > 0;
    },
    _checkDirection: function _checkDirection(direction, directionPart) {
        return direction.indexOf(directionPart) >= 0;
    },
    _calcZIndexGroupLevel: function _calcZIndexGroupLevel() {
        return this.props.zIndexGroupLevel || this.context.zIndexGroupLevel || 0;
    },


    // TODO: dead code https://st.yandex-team.ru/ISL-4096
    _setPreventHideByClick: function _setPreventHideByClick() {
        var curPopup = this;
        do {
            curPopup._preventHideByClick = true;
            curPopup = curPopup._getParentPopup();
        } while (curPopup);
    },
    _captureZIndex: function _captureZIndex() {
        if (this._zIndexGroupLevel === null) {
            this._zIndexGroupLevel = this._calcZIndexGroupLevel();
        }

        var visiblePopupsZIndexes = this.__self._visiblePopupsZIndexes;
        var level = this._zIndexGroupLevel;
        var zIndexes = visiblePopupsZIndexes[level];
        var prevZIndex = this._zIndex;

        if (!zIndexes) {
            zIndexes = visiblePopupsZIndexes[level] = [(level + 1) * this.__self.ZINDEX_FACTOR];
        }

        this._zIndex = zIndexes[zIndexes.length - 1] + 1;
        zIndexes.push(this._zIndex);

        if (this._zIndex !== prevZIndex) {
            this._style.popup.zIndex = this._zIndex;
        }

        return this;
    },
    _releaseZIndex: function _releaseZIndex() {
        var zIndexes = this.__self._visiblePopupsZIndexes[this._zIndexGroupLevel];

        if (zIndexes && zIndexes.length > 1) {
            if (this.drawn) {
                zIndexes.splice(zIndexes.indexOf(this._zIndex), 1);
            }
            this.drawn = false;
        }

        return this;
    },
    _recaptureZIndex: function _recaptureZIndex() {
        this._releaseZIndex();
        this._zIndexGroupLevel = null;

        return this._captureZIndex();
    }
}, {
    propTypes: {
        theme: _propTypes2.default.string,
        target: _propTypes2.default.oneOf(['anchor', 'position']).isRequired,
        view: _propTypes2.default.oneOf(['classic', 'default']),
        tone: _propTypes2.default.string,
        hasTail: _propTypes2.default.bool,
        tailSize: _propTypes2.default.number,
        position: _propTypes2.default.object,
        autoclosable: _propTypes2.default.bool,
        visible: _propTypes2.default.bool,
        directions: _propTypes2.default.array,
        mainOffset: _propTypes2.default.number,
        zIndexGroupLevel: _propTypes2.default.number,
        secondaryOffset: _propTypes2.default.number,
        viewportOffset: _propTypes2.default.number,
        tailOffset: _propTypes2.default.number,
        onMouseOver: _propTypes2.default.func,
        onMouseLeave: _propTypes2.default.func,
        calcPossible: _propTypes2.default.func
    },
    defaultProps: {
        view: 'classic',
        target: 'anchor',
        directions: AVAILABLE_DIRECTIONS,
        secondaryOffset: 0,
        tailOffset: 0,
        zIndexGroupLevel: 0
    },
    _visiblePopupsZIndexes: {},
    ZINDEX_FACTOR: 1000,
    VIEWPORT_ACCURACY_FACTOR: 0.99,
    UPDATE_TARGET_VISIBILITY_THROTTLING_INTERVAL: 100,
    inject: _reactDom2.default.unstable_renderSubtreeIntoContainer,
    contextTypes: {
        registerChildPopup: _propTypes2.default.func,
        unRegisterChildPopup: _propTypes2.default.func,
        zIndexGroupLevel: _propTypes2.default.number
    },
    childContextTypes: {
        registerChildPopup: _propTypes2.default.func,
        unRegisterChildPopup: _propTypes2.default.func,
        zIndexGroupLevel: _propTypes2.default.number
    }
});